
import { useState } from "react";

export const useFilter = <T,>( data: T[], filterBy: ( item: T, filtro: string ) => boolean ) => {

    const [filtro, setFiltro] = useState( '' );

    const dataFiltrada = data.filter( ( item ) => filterBy( item, filtro ));

    return { filtro, setFiltro, dataFiltrada };
};
